import { jsx as _jsx } from "react/jsx-runtime";
import { InviteTimerCounter } from './invite-timer-counter';
import { InviteTimerActionView } from './invite-timer-action';
import { useToggle } from '../../../../../infra/small-tools/use-toggle';
var timerOptions = Array.from({ length: 12 }, function (_, index) { return (index + 1) * 5; });
export var InviteTimerActionContainer = function (props) {
    var inviteTimerModal = useToggle();
    var handleSubmitTimerModal = function (event) {
        event.preventDefault();
        var formData = new FormData(event.currentTarget);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var selectedTimeout = Number(formData.get('selectedTimeout'));
        // TODO set API request to start time countdown with selectedTimeout here
        inviteTimerModal.setOff();
    };
    return props.countdownTo ? (_jsx(InviteTimerCounter, { countdownTo: props.countdownTo })) : (_jsx(InviteTimerActionView, { onActionButtonClicked: inviteTimerModal.setOn, timerOptions: timerOptions, showActionModal: inviteTimerModal.isOn, onCloseModal: inviteTimerModal.setOff, onSubmitModal: handleSubmitTimerModal }));
};
InviteTimerActionContainer.defaultProps = {
    countdownTo: null,
};
